module.exports = __webpack_public_path__ + "img/24_61.f3084aeb.png";